<!-- ESCOLAR -->
<form #formConsultar="ngForm">
    <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <combo-tipo-escola fxFlex="30" fxFlexOffset="20px"
                           [selecionado]="tipoEscola"
                           [obrigatorio]="false"
                           (valorChange)="onTipoEscolaChange($event)">
        </combo-tipo-escola>


        <div ngModelGroup="comboFamiliar" fxFlex>
            <combo-pesquisavel #comboEscola nome="escola" label="Escola" [itens]="escolas" itemDescricao="nome" itemId="id"
                               [showDisplayId]="false" [obrigatorio]="false" placeholder="Informe o nome da escola"
                               [(valor)]="aluno.pessoaFisica.escola" (valorChange)="preencherRa($event)">
            </combo-pesquisavel>
        </div>

        <mat-form-field fxFlex="30">
            <input matInput maxlength="30" [(ngModel)]="nomeRa" name="ra" placeholder="RA" disabled>
        </mat-form-field>

    </div>
    <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <mat-form-field fxFlex fxFlexOffset="20px">
            <input matInput maxlength="200" name="descricaoEscolaImportacao" placeholder="Escola Importação"
                   [(ngModel)]="aluno.descricaoEscolaImportacao">
        </mat-form-field>

        <mat-form-field fxFlex>
            <input matInput maxlength="200" name="descricaoSerieImportacao" placeholder="Série Importação"
                   [(ngModel)]="aluno.descricaoSerieImportacao">
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <combo-serie-escolar fxFlex fxFlexOffset="20px"
                             [selecionado]="aluno.pessoaFisica.serieEscolar"
                             [obrigatorio]="false"
                             (valorChange)="onSerieEscolarChange($event)">
        </combo-serie-escolar>
        <combo-turno fxFlex
                     [selecionado]="aluno.pessoaFisica.turno"
                     [obrigatorio]="false"
                     (valorChange)="onTurnoChange($event)">
        </combo-turno>
    </div>
</form>
